import "@ms-mwf/moray/dist/css/themes/main-xbox.css";
import "./App.css";
import "./XdsStyling.module.scss";

import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";

import { FeatureGate, getBooleanFeatureGateEnabled } from "@gamedev-web/gamedev-sdk-core";
import { Theme, ThemeVersion, UserColors, XDSContextWeb } from "@gaming/xds-foundation";
import { loadTheme, XdsTheme, xdsThemeToDataTheme } from "@gaming/xds-react-js";

import { ErrorBoundary } from "./components/ErrorBoundary";
import { RootState } from "./redux/reducers";
import { Shell } from "./shell";

const App = () => {
  const [platform, setPlatform] = useState("");
  const enableCookieSourceDebugConsole = useSelector(state =>
    getBooleanFeatureGateEnabled(state as RootState, FeatureGate.EnableCookieSourceDebugConsole)
  );

  useEffect(() => {
    loadTheme(XdsTheme.DefaultLight);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setPlatform(navigator.platform);
  }, []);

  return (
    <ErrorBoundary>
      {() => (
        <div className="appBackground">
          <XDSContextWeb.Provider
            value={{
              theme: Theme.Light,
              themeVersion: ThemeVersion.WebPolaris,
              userColors: UserColors.XboxGreen,
            }}
          >
            <Helmet defaultTitle="Microsoft Game Dev">
              {/* eslint-disable-next-line jsx-a11y/html-has-lang */}
              <html data-platform={platform} />
              {enableCookieSourceDebugConsole && (
                <script>
                  {`origDescriptor = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie');
                    Object.defineProperty(document, 'cookie', {
                      get() {
                        return origDescriptor.get.call(this);
                      },
                      set(value) {
                        let obj = {};
                        try { Error.captureStackTrace(obj, value); }
                        catch(e) { obj = e; } // this is needed to make it work in FF
                        console.log("Cookie: ", value);
                        console.log("Cookie Stack: ", obj.stack);
                        return origDescriptor.set.call(this, value);
                      },
                      enumerable: true,
                      configurable: true
                    });`}
                </script>
              )}
              <body data-theme={xdsThemeToDataTheme(XdsTheme.DefaultLight)} />
            </Helmet>
            <Shell />
          </XDSContextWeb.Provider>
        </div>
      )}
    </ErrorBoundary>
  );
};

export default App;
